import React from 'react'

const Mobile = () => (
    <svg width="32" height="54" viewBox='0 0 32 54' fill="none" xmlns="http://www.w3.org/2000/svg"><rect x=".75" y=".75" width="30.5" height="52.5" rx="3.25" stroke="#000" strokeWidth="1.5"/><path stroke="#000" d="M1 6.5h30M1 44.5h30M13 48.5h6"/></svg>
)

export default Mobile